
export class CountryModel {
  cty_key: string = undefined;
  cty_code: string = undefined;
  cty_long_name: string = undefined;
  cty_iso_2: string = undefined;

  constructor(source?: any) {
    if (source) {
      for (const key in this) {
        if (key in source) {
          this[key] = source[key];
        }
      }
    }
  }
}
